import { buildCsv } from './downloadOriginCsv';
import { PRODUCTION_BASE_COLUMNS } from './downloadReportCatalog';

export { buildCsv };

export const productionCsvFileName = (subtype, from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  const kind = subtype === 'sales_by_variant' ? 'variant' : 'base';
  return `production-${kind}-${safePart(from)}-to-${safePart(to)}.csv`;
};

export const productionCsvMetricCells = (metrics = {}) =>
  PRODUCTION_BASE_COLUMNS.map(column => metrics[column] ?? 0);
